import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'Lib/jquery.cookie.min';
import 'Lib/jquery.scrolltofixed';

"use strict";

var ViewCheckout = Backbone.View.extend({

	// Styleguide Init Function
	initialize: function (opts) {
		console.log('init checkout');
		var self = this;
					
		self.initCheckout()
		
	},
	
	events: {
	},
	
	initCheckout: function () {
		var self = this;
	
    //Doesn't follows Regular 1R Script structure
    //Author windsor@1r
    var CheckoutPage = {};

    // a minimal jQuery library for reacting to innerHTML changes
    // Sourced from https://jsfiddle.net/ecmanaut/jRbEz/ 
    (function($) {
      $.fn.change = function(cb, e) {
        e = e || { subtree:true, childList:true, characterData:true };
        $(this).each(function() {
          function callback(changes) { cb.call(node, changes, this); }
          var node = this;
          (new MutationObserver(callback)).observe(node, e);
        });
      };
    })(jQuery);

    CheckoutPage.init = {
        initScripts: function(){

        // CheckoutPage.init.validateAddress();
        CheckoutPage.init.fixSidebar();
        CheckoutPage.init.itemCounter();
        CheckoutPage.init.addProductImgBg();
        CheckoutPage.init.updateFlags();

        $(document).on('page:load page:change', function () {
          CheckoutPage.init.addProductImgBg();
        });

        $(".order-summary__section--total-lines,.order-summary__section--discount").on('DOMSubtreeModified',function(){
          console.log('order-summary DOMSubtreeModified');
          CheckoutPage.init.updateFlags();
        });

        // $(".product-table").on('DOMSubtreeModified',function(e){
        // $(".product-table").change(function(changes, observer){
          //console.log('element ' + this.id, changes, observer);
          // CheckoutPage.init.addProductImgBg();
        // });

        // $('#checkout_shipping_address_address1').change(function(e){
          // console.log('address update');
          // CheckoutPage.init.addProductImgBg();
        // });

        // adjust contact info span widths
        // var labels = $('.review-block__label');
        // var widths = labels.map(function () { return Math.ceil($(this).width()); }).get();
        // var maxWidth = Math.max.apply(null, widths);
        // labels.map(function () { $(this).css('flex-basis', 'calc(${maxWidth}px + 1.15rem)'); });

        if($(window).width() < 1025){
          $('.sg_box').appendTo('#order-summary');
          $('#sr_headerDiv').prependTo('#order-summary');
        }
      },

      itemCounter: function(){
          // var self = this;
          var itemCount = parseInt(0);
          var countDisplay = $(".sidebar__content--header").find(".item-count");
          $('.product-thumbnail__quantity').each(function(i,e){
              itemCount = itemCount + parseInt($(e).text());
              console.log(itemCount);
              if(itemCount == 1){
                  countDisplay.text("("+itemCount+")");
              }else{
                  countDisplay.text("("+itemCount+")");
              }
          });
      },

      validateAddress: function(){
        // var regex = /\b[p](ost(al)?)?\.?(\s+)?([o](ffice)?)?\.?(\s+)?(box)?(\s+)?[\w]+\b/i;
        var regex = /\b(?:po\s+box|apo\s+box|postal\s+office|p.o.\s+box|post\s+office)\b/i;
            var $contactForm = $('[data-step="contact_information"]').find('form');
            var $addressField1 = $('#checkout_shipping_address_address1');
            var $addressField2 = $('#checkout_shipping_address_address2');
            var $fieldContainer = $('[data-address-field="address1"]');

            $contactForm.on('submit', function(e) {
              var test = regex.test($addressField1.val());
              var test2 = regex.test($addressField2.val());
              var $errorMessage = $("<p class='field__message field__message--error po-box-error' id='error-for-address1'>Sorry! We are unable to ship to PO Boxes.</p>");
              
              if(test === true){
                e.preventDefault();
                $(".po-box-error").remove();
                $fieldContainer.append($errorMessage);
                $errorMessage.css("display", "block");
              }

              if(test2 === true){
                e.preventDefault();
                $(".po-box-error").remove();
                $fieldContainer.append($errorMessage);
                $errorMessage.css("display", "block");
              }
              
            });

      },//validateAddress

      addProductImgBg: function(){
        // $('.product__description__property').each(function(i,elem){
        // 	var propertyText = $(elem).text().trim();
        // 	var productBGColor = '';
        // 	var productWrapper = $(elem).parents('.product');
        // 	var productImage = productWrapper.find('.product__image');

        // 	if(propertyText.indexOf('bg: ') > -1){
        // 		$(elem).hide();
        // 		productBGColor = propertyText.replace('bg: ','');
        // 		// console.log(productBGColor);
        // 		productImage.css({'background':productBGColor});
        // 	}
        // 	productImage.addClass('show');
        // });

        //     // show all products that don't have bg color as well
        //     var productImage = $('.sidebar').find('.product__image');
        //     productImage.addClass('show');

        // get full size image
        $('.product-thumbnail__image').map(function () {
          var src = $(this).attr('src');
          $(this).attr('src', src.replace('_small', '_300x'));
        });

      },//addProductImgBg

      fixSidebar: function(){
            var $sideBar = $('.sidebar__content');
            console.log($sideBar.outerHeight(true));
            if( $sideBar.length > 0 && $(window).width() > 1000 && $(window).height() > $sideBar.outerHeight(true) ){
              console.log('fixSidebar');
              $sideBar.addClass('scrollable');
              $sideBar[0].scrollTop = $sideBar[0].scrollHeight;
                $sideBar.scrollToFixed({
                    bottom: 0,
                    removeOffsets: true,
                    zIndex: 9,
                    dontSetWidth: true,
                    marginTop: $('.site-header').outerHeight(true),
                    limit: function(){
                        var limit = $('.main').offset().bottom - $sideBar.outerHeight(true);
                        return limit;
                    },
                    fixed: function(){
                        $(this).removeClass('unFixed');
                        $(this).addClass('isFixed');
                    },
                    unfixed: function(){
                        $(this).removeClass('isFixed');
                        $(this).addClass('unFixed');
                    }
                });
            }
      },//fixSidebar
      
      updateFlags: function(){
        var product__description__property = $('.product__description__property');
        let products = document.querySelectorAll('.product-table .product');
        let checkout_items = Shopify?.checkout?.line_items;

        if(products){
          products.forEach(function(item, index){
            let variant_id = $(item).data('variant-id');
            if(checkout_items){
              checkout_items.forEach(function(checkout_item){
                if(checkout_item.variant_id == variant_id){
                  let properties = checkout_item.properties;
                  if(properties){
                    Object.keys(properties).forEach(function(key){
                      var property = properties[key];
                      if(property == 'EXCHANGE ONLY'){
                        setTimeout(
                          function(){
                            $('.product-table .product').eq(index).find('.product__description').append('<span class="product__description__property order-summary__small-text final-sale" style="display: block;"><div class="product-flags"><div class="flag final-sale"><span>EXCHANGE ONLY</span></div></div></span>');
                          }
                        ,1000);
                      }
                      if(property == 'FINAL SALE'){
                        setTimeout(
                          function(){
                            $('.product-table .product').eq(index).find('.product__description').append('<span class="product__description__property order-summary__small-text final-sale" style="display: block;"><div class="product-flags"><div class="flag final-sale"><span>FINAL SALE</span></div></div></span>');
                          }
                        ,1000);
                      } 
                    });
                  }
                }
              });
            }
          });
        }

        if(product__description__property.length){
          product__description__property.each(function(index, ele){
            //Somehow without the 1 second timeout the following updates won't work
            // if($(ele).html().indexOf('FINAL SALE') > 0){
            //   setTimeout(
            //     function(){
            //       $('.product__description__property').eq(index).addClass('final-sale');
            //       $('.product__description__property').eq(index).html('<div class="product-flags"><div class="flag final-sale"><span>FINAL SALE</span></div></div>');
            //       $('.product__description__property').eq(index).css('display', 'block');
            //     }
            //   ,1000);
            // }//Final Sale

            if($(ele).html().indexOf('Pre Order') > 0){
              var current_PO_text = $('.product__description__property').eq(index).html().replace('Pre Order, ','');
              setTimeout(
                function(){
                  $('.product__description__property').eq(index).html(current_PO_text);
                  $('.product__description__property').eq(index).addClass('pre-order');
                  $('.product__description__property').eq(index).prepend('<div class="product-flags"><div class="flag pre-order"><span>Pre-Order</span></div></div>');
                }
              ,1000);
            }

          });
        }

      }//updateFlags
    }

    if (window.jQuery){
      $(function() {
        CheckoutPage.init.initScripts();
      });
    }

	},

});

export default ViewCheckout;